import { action } from 'mobx';
import { observer } from 'mobx-react';
import { bind, CardItem, Enums, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';

export interface IDisplayMeasurmentsCardProps {
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
    readonly loading?: boolean;
}
@observer
export class DisplayMeasurmentsCard extends React.Component<IDisplayMeasurmentsCardProps> {
    public render() {
        const statusPoll = this.props.statusPoll;
        const environmentalStatus = statusPoll?.environmentalStatus;

        return (
            <StatusCard title="Sensors" loading={this.props.loading}>
                {statusPoll?.sensors
                    ?.filter(
                        s =>
                            s.name?.toLowerCase().indexOf('door') == -1 &&
                            s.name?.toLowerCase().indexOf('suppressor') == -1 &&
                            s.id != Mri.WebApi.MeasurementId.AnyDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.SurgeSuppressorFailedStatus &&
                            s.id != Mri.WebApi.MeasurementId.BottomRearDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.FrontDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.LeftDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.RearDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.RightDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.SAMDoorOpenStatus &&
                            s.id != Mri.WebApi.MeasurementId.CoolVuZone1Source &&
                            s.id != Mri.WebApi.MeasurementId.CoolVuZone2Source &&
                            s.id != Mri.WebApi.MeasurementId.CoolVuZone1Celsius &&
                            s.id != Mri.WebApi.MeasurementId.CoolVuZone2Celsius &&
                            s.id != Mri.WebApi.MeasurementId.HumidityLevel
                    )
                    .map((s, idx) => (
                        <CardItem
                            key={idx}
                            label={s.name ?? Enums.toString(Enums.MeasurementId, s.id)}
                            value={
                                s.floatValue ?? s.doubleValue ?? s.intValue ? (
                                    <span>
                                        {s.floatValue?.toFixed(2) ?? s.doubleValue?.toFixed(2) ?? s.intValue}{' '}
                                        {s.units == 'C' ? ' ℃' : s.units}
                                    </span>
                                ) : (
                                    '-'
                                )
                            }
                        />
                    ))}

                {environmentalStatus?.closedLoopTemp != null && (
                    <CardItem
                        label="Closed Loop Temperature"
                        value={environmentalStatus.closedLoopTemp.toFixed(2) + ' ℃'}
                    />
                )}

                {environmentalStatus?.maxBacklightTemp != null && (
                    <CardItem
                        label="Max Backlight Temperature"
                        value={environmentalStatus.maxBacklightTemp.toFixed(2) + ' ℃'}
                    />
                )}

                {environmentalStatus?.maxPowerSupplyTemp != null && (
                    <CardItem
                        label="Max Power Supply Temperature"
                        value={environmentalStatus.maxPowerSupplyTemp.toFixed(2) + ' ℃'}
                    />
                )}

                {environmentalStatus?.humiditySensorTemp != null && (
                    <CardItem
                        label="Humidity Sensor Temperature"
                        value={environmentalStatus.humiditySensorTemp.toFixed(2) + ' ℃'}
                    />
                )}

                {environmentalStatus?.relativeHumidity != null && (
                    <CardItem label="Relative Humidity" value={environmentalStatus.relativeHumidity.toFixed(2) + '%'} />
                )}

                {environmentalStatus?.calculatedDewpoint != null && (
                    <CardItem
                        label="Calculated Dewpoint"
                        value={environmentalStatus.calculatedDewpoint.toFixed(2) + ' ℃'}
                    />
                )}

                {environmentalStatus?.dewpointSpread != null && (
                    <CardItem label="Dewpoint Spread" value={environmentalStatus.dewpointSpread.toFixed(2) + ' ℃'} />
                )}

                {statusPoll?.sensors
                    ?.filter(
                        s =>
                            s.name?.toLowerCase().includes('door') ||
                            s.id == Mri.WebApi.MeasurementId.AnyDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.BottomRearDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.FrontDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.LeftDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.RearDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.RightDoorOpenStatus ||
                            s.id == Mri.WebApi.MeasurementId.SAMDoorOpenStatus
                    )
                    .map((s, idx) => (
                        <CardItem key={idx} label={s.name!} value={s.boolValue ? 'OPEN' : 'Closed'} />
                    ))}

                {statusPoll?.sensors
                    ?.filter(
                        s =>
                            s.name?.toLowerCase().includes('suppressor') ||
                            s.id == Mri.WebApi.MeasurementId.SurgeSuppressorFailedStatus
                    )
                    .map((s, idx) => (
                        <CardItem key={idx} label={s.name!} value={s.boolValue ? 'Fail' : 'OK'} />
                    ))}

                {statusPoll?.sensors
                    ?.filter(
                        s =>
                            s.id == Mri.WebApi.MeasurementId.CoolVuZone1Source ||
                            s.id == Mri.WebApi.MeasurementId.CoolVuZone2Source ||
                            s.id == Mri.WebApi.MeasurementId.CoolVuZone1Celsius ||
                            s.id == Mri.WebApi.MeasurementId.CoolVuZone2Celsius
                    )
                    .map((s, idx) => (
                        <CardItem key={idx} label={s.name!} value={this.measurementMask(s)} />
                    ))}
            </StatusCard>
        );
    }

    @bind
    @action
    public measurementMask(measurement: Mri.WebApi.Measurement) {
        if (!measurement || !measurement.intValue) return '-';

        /* eslint-disable no-bitwise */
        const source = measurement.intValue & Mri.WebApi.MeasurementId.SENSOR_ID_SOURCE_MASK;
        const id = measurement.intValue & Mri.WebApi.MeasurementId.SENSOR_ID_MASK;
        /* eslint-enable no-bitwise */
        const title = Enums.BriefMeasurementId.has(id)
            ? Enums.toString(Enums.BriefMeasurementId, id)
            : Enums.toString(Enums.MeasurementId, id);

        return title;
    }
}
